module.exports = __webpack_public_path__ + "img/filter.5917bc61.svg";